"use strict";

exports.__esModule = true;
var _ChartTooltip = require("./ChartTooltip");
Object.keys(_ChartTooltip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChartTooltip[key]) return;
  exports[key] = _ChartTooltip[key];
});